module.exports = __webpack_public_path__ + "img/phone.ed146f57.jpg";